import { render, staticRenderFns } from "./spacer.vue?vue&type=template&id=422dfa64&scoped=true"
import script from "./spacer.vue.ts?vue&type=script&lang=ts&external"
export * from "./spacer.vue.ts?vue&type=script&lang=ts&external"
import style0 from "./spacer.vue?vue&type=style&index=0&id=422dfa64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422dfa64",
  null
  
)

export default component.exports